import { Autocomplete, TextField } from '@mui/material';

export interface TagsInputProps {
    value: Array<{ name: string }>;
    onChange: (tags: Array<{ name: string }>) => void;
    options: Array<{ name: string }>;
    loading?: boolean;
    className?: string;
    label?: string;
    placeholder?: string;
}

export const TagsInput = ({
    value,
    onChange,
    options,
    loading = false,
    className,
    label = 'Tags',
    placeholder = 'Add or type tags',
}: TagsInputProps) => {
    return (
        <Autocomplete
            multiple
            freeSolo
            options={options}
            getOptionLabel={(option) =>
                typeof option === 'string' ? option : option.name
            }
            value={value}
            onChange={(_, newValue) => {
                onChange(
                    newValue.map((tag) =>
                        typeof tag === 'string' ? { name: tag } : tag,
                    ),
                );
            }}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder={placeholder}
                />
            )}
            className={className}
        />
    );
};
